Vue.directive('focus', require('./src/directives/Focus.vue'));